export const MSAL_CLIENT_ID = import.meta.env.PUBLIC_MSAL_CLIENT_ID
export const MSAL_TENANT_ID = import.meta.env.PUBLIC_MSAL_TENANT_ID
export const MSAL_SCOPE = import.meta.env.PUBLIC_MSAL_SCOPE
export const MSAL_ROLE_ID_EV_EMP_UI_READER = import.meta.env.PUBLIC_MSAL_ROLE_ID_EV_EMP_UI_READER
export const MSAL_ROLE_ID_EV_EMP_UI_DEVELOPER = import.meta.env.PUBLIC_MSAL_ROLE_ID_EV_EMP_UI_DEVELOPER

export const API_URI = import.meta.env.PUBLIC_API_URI

export const EV_BACKEND_URI = import.meta.env.PUBLIC_EV_BACKEND_URI
export const BILLING_URI = import.meta.env.PUBLIC_BILLING_URI
export const KBP_URI = import.meta.env.PUBLIC_KBP_URI
export const MEK_URI = import.meta.env.PUBLIC_MEK_URI
export const TARIFF_MANAGEMENT_URI = import.meta.env.PUBLIC_TARIFF_MANAGEMENT_URI
